import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ca7b1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "rec-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 相关阅读 ", -1))
const _hoisted_3 = { class: "skeleton-box" }
const _hoisted_4 = { class: "rec-list" }

import {computed, inject, ref} from 'vue';
import {Skeleton} from 'vant';
import {useRouter} from 'vue-router';
import InfoItem from '@/components/InfoItem.vue';
import {haboClickReport} from '@/plugins/haboConfig';
import {useRecommend} from '@/service/detail';
import {useHaboInfo} from '@/hooks/useHaboInfo';



const __default__ = {
  name: 'Recommend',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    commentShow: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  commentShow?: boolean;
}

const router = useRouter();
const infoId = ref<number>(+router.currentRoute.value.params.infoId as number);
const {cmsCode} = useHaboInfo();



const {
  data,
  isFetching,
  isFinished,
  error,
  execute,
} = useRecommend({informationId: infoId.value, cmsCategoryId: +cmsCode || 0});
const listData = computed(() => data.value?.newsRecommend || []) as unknown as InfoItem[];


const handleRouteByBtn = inject('handleRouteByBtn') as (type: 'forward' | 'backward') => void;
// const reload = inject('reload') as () => void;
const toDetail = (infoId: number, role: number) => {
  haboClickReport('INFO_REC_CLICK', {
    news_level: role,
    click_source: 2,
    news_id: infoId,
  });
  handleRouteByBtn('forward');
  const {query} = router.currentRoute.value;
  router.push({name: 'detail', params: {infoId}, query});
};


return (_ctx: any,_cache: any) => {
  return (_unref(listData)?.length || -1 > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Skeleton), {
            title: "",
            row: 2,
            avatar: "",
            "avatar-shape": "square"
          }),
          _createVNode(_unref(Skeleton), {
            title: "",
            row: 2,
            avatar: "",
            "avatar-shape": "square"
          }),
          _createVNode(_unref(Skeleton), {
            title: "",
            row: 2,
            avatar: "",
            "avatar-shape": "square"
          })
        ], 512), [
          [_vShow, (!_unref(isFinished) || _unref(isFetching))]
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, index) => {
            return (_openBlock(), _createBlock(InfoItem, {
              key: item.informationId,
              "no-border": props.commentShow?(index + 1 !== _unref(listData).length):true,
              "item-info": item,
              "to-detail": toDetail
            }, null, 8, ["no-border", "item-info"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})